
const timeRe = (time) => {
  return time < 10 ? '0' + time : time
}
const timestampToTime = (timestamp, b) => {
  const date = new Date(timestamp * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + b
  // const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + b
  const M = timeRe(date.getMonth() + 1) + b
  const D = timeRe(date.getDate()) + ' '
  const h = timeRe(date.getHours()) + ':'
  const m = timeRe(date.getMinutes()) + ':'
  const s = timeRe(date.getSeconds())
  return Y + M + D + h + m + s
}
// date.setTime(date.getTime() - 24 * 60 * 60 * 1000)
const timestampToDate = (timestamp, b) => {
  const date = new Date(timestamp * 1000 - 24 * 60 * 60 * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + b
  // const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + b
  const M = timeRe(date.getMonth() + 1) + b
  const D = timeRe(date.getDate()) + ' '
  return Y + M + D
}
export { timestampToTime, timestampToDate }
